import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const DeliveryPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO title="Delivery Information" description="Free UK delivery on orders over £50. Fast, reliable shipping on all hair extensions, wigs and braids from Plymhair." url="/delivery" />
      <Navbar />

      <section className="bg-foreground text-primary-foreground py-24 md:py-32 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display text-5xl md:text-7xl mb-4">
            Delivery <span className="italic font-normal">Info</span>
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 prose prose-neutral dark:prose-invert font-body prose-headings:font-display prose-h2:text-primary prose-h3:text-primary">
          <p>This policy contains details of the delivery methods, periods and charges that apply to orders made through our website, by telephone, or by email. This policy forms part of the contract of sale between you and us.</p>

          <h2>Geographical Information</h2>
          <p>We deliver nationally and internationally, although limitations may apply on certain products and delivery methods. We may require additional identification and/or address checks prior to dispatching items. If we cannot complete necessary checks, your order may be cancelled and payment refunded in full.</p>

          <h2>Delivery Methods & Periods</h2>
          <ul>
            <li><strong>UK Standard (Royal Mail 1st Class Recorded):</strong> Typical delivery within 1 week — <strong>£6.95</strong></li>
            <li><strong>UK Saver (Royal Mail 2nd Class Recorded):</strong> Typical delivery within 2 weeks — <strong>£5.99</strong></li>
            <li><strong>EU / EEA International (Royal Mail International):</strong> Typical delivery within 1–3 weeks</li>
            <li><strong>Rest of World (Royal Mail International):</strong> Typical delivery within 1–3 weeks</li>
          </ul>
          <p>Our main delivery service provider is Royal Mail. For deliveries outside the UK, Royal Mail handles carriage within the UK, then transfers to local domestic carriers for the remaining journey.</p>
          <p>If you place your order after 4pm on a working day or on a non-working day, delivery periods run from the close of business on the next working day.</p>
          <p>Delivery periods are indicative only. We will make every effort to deliver in good time but do not guarantee delivery before the end of the stated period.</p>

          <h2>Delivery Restrictions</h2>
          <h3>United Kingdom</h3>
          <ul>
            <li>Bottled products (shampoo, conditioner, etc.): up to 3 bottles via Saver delivery; up to 4 bottles via Standard delivery.</li>
          </ul>
          <h3>International</h3>
          <ul>
            <li>Bottled products: maximum of 4 bottles per order.</li>
            <li>We are unable to send products containing flammable substances.</li>
          </ul>

          <h2>Delivery Tracking, Receipt & Collection</h2>
          <p>Orders are dispatched by trackable service. All deliveries use a 'signed for' service — a signature must be provided. If products remain undelivered after at least one attempt, a card will be left with collection instructions.</p>

          <h2>Delivery Problems</h2>
          <p>If you experience any problems, please contact us. If delivery failure is your fault (wrong address, nobody available to sign, etc.), we reserve the right to charge for re-delivery.</p>

          <h2>Returns Policy</h2>
          <p>You may return a product within <strong>14 days</strong> provided it is unused, unworn, free from scents or residue, in its original unopened packaging with tags attached, and in a condition enabling us to sell as new.</p>
          <p>For wigs and hairpieces: items must not be wet, brushed, or styled in any way.</p>

          <h3>Returns Procedure</h3>
          <p>Contact us to obtain a return authorisation number. Return products to our registered address quoting the number provided. You are responsible for return postage costs.</p>

          <h3>Exclusions</h3>
          <p>The following may not be returned: products delivered outside the EU/EEA, toiletries and cosmetics, items made to specification or personalised, gift cards, bottled/aerosol products, eyebrows removed from packaging, accessories, and any wired items changed from original position.</p>

          <h3>Refunds & Exchanges</h3>
          <p>We will refund the purchase price (not original delivery or return postage costs) using the same payment method, within 14 days of receiving the returned item. Used discount codes will not be re-issued.</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DeliveryPage;
